module.exports = __webpack_public_path__ + "static/Growthlead-33d6164cfe7f47bb85a9cd3def166d2c.png";